// components/doctors/DoctorModal.jsx
import React from 'react';
import { motion } from 'framer-motion';
import DoctorAvailability from './DoctorAvailability';

const COLORS = {
  primary: "#0760ad",
  secondary: "#118a94",
  white: "#FFFFFF"
};

const DoctorModal = ({ doctor, onClose, onBookAppointment }) => {
  const specialties = Array.isArray(doctor.specialty) 
    ? doctor.specialty.map(s => s.name).join(', ')
    : doctor.specialty;

  const doctorImage = doctor.image_url || doctor.image;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
      >
        <div className="p-6">
          <div className="flex justify-between items-start mb-6">
            <h2 className="text-2xl font-bold" style={{ color: COLORS.primary }}>
              {doctor.name}
            </h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="md:col-span-1">
              <div className="bg-gray-100 rounded-lg overflow-hidden">
                {doctorImage ? (
                  <img src={doctorImage} alt={doctor.name} className="w-full h-auto" />
                ) : (
                  <div className="h-64 flex items-center justify-center text-gray-400">
                    {doctor.gender === 'Female' ? '👩‍⚕️' : '👨‍⚕️'}
                  </div>
                )}
              </div>
            </div>

            <div className="md:col-span-2">
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-medium" style={{ color: COLORS.secondary }}>
                    {specialties}
                  </h3>
                  <p className="text-gray-600">{doctor.qualification}</p>
                </div>

                <div className="border-t border-b border-gray-200 py-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <p className="text-sm text-gray-500">Experience</p>
                      <p className="font-medium">{doctor.experience} years</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Gender</p>
                      <p className="font-medium">{doctor.gender}</p>
                    </div>
                  </div>
                </div>

                {/* Add working hours section */}
                <div>
                  <h4 className="font-medium mb-2">Working Hours</h4>
                  <DoctorAvailability 
                    availability={doctor.availability} 
                    workingHours={doctor.working_hours} 
                  />
                </div>

                <div>
                  <h4 className="font-medium mb-2">About Dr. {doctor.name.split(' ')[1]}</h4>
                  <p className="text-gray-700">{doctor.about}</p>
                </div>

                <div className="pt-4">
                  <button
                    onClick={onBookAppointment}
                    className="w-full py-3 px-6 rounded-md font-medium text-white"
                    style={{ backgroundColor: COLORS.primary }}
                  >
                    Book Appointment
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default DoctorModal;